export const PickUpReturnStates = {
    INITIAL: 1,
    SELECT_PICKUP_LOCATION: 2,
    SELECT_RETURN_LOCATION: 3,
    SELECT_PICKUP_DATETIME: 4,
    SELECT_RETURN_DATETIME: 5,
};
